import Tooltip from "@/v2-ui/tooltip"
import Badge from "@/v2-backoffice-client/components/badge"
import RelativeDate from "@/v2-backoffice-client/components/RelativeDate"
import type { PrivacyPolicyRow } from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.types"

export type TenantPrivacySourceCellProps = {
  row: PrivacyPolicyRow
}

// The first column of the per-source table: which data source the row is,
// and where its policy stands — never configured, or when it last changed
// and why. The name truncates to keep the pills beside it visible, so it
// reveals itself (and the source's description) on hover. An unsaved edit
// is the one state that needs a pill, because it is the one the operator
// has to act on.
function TenantPrivacySourceCell(props: TenantPrivacySourceCellProps) {
  const { row } = props

  const sourceName =
    row.ExternalSourceName ?? `Source ${row.ExternalSourceCode}`
  const updatedAt = row.UpdatedAt ?? row.CreatedAt

  return (
    <div className="flex min-w-0 flex-col">
      <div className="flex items-center gap-2">
        <Tooltip>
          <Tooltip.Trigger asChild>
            <span className="cursor-help truncate font-medium">
              {sourceName}
            </span>
          </Tooltip.Trigger>
          <Tooltip.Content side="top" className="ui-tooltip-content--panel">
            <div className="flex max-w-xs flex-col gap-1 p-3 text-xs">
              <p className="font-medium">{sourceName}</p>
              {row.ExternalSourceDescription && (
                <p className="text-muted-foreground">
                  {row.ExternalSourceDescription}
                </p>
              )}
            </div>
          </Tooltip.Content>
        </Tooltip>
        {row.edits && (
          <Badge size="tiny" variant="warning">
            Unsaved
          </Badge>
        )}
        {row.HasPolicyRow && row.Justification && (
          <Badge size="tiny" variant="outline" tooltip={row.Justification}>
            Justified
          </Badge>
        )}
      </div>

      <span className="text-xs text-muted-foreground">
        {row.HasPolicyRow ? (
          <>
            Updated <RelativeDate date={updatedAt} />
          </>
        ) : (
          "Not configured"
        )}
      </span>
    </div>
  )
}

export default TenantPrivacySourceCell
